export const SOURCE = {
    GOOGLE: 'Google Guaranteed'
};
export const LSA_DNIS =  "2142349539";
export const VALIDATORS = {
    TYPE: "type",
    MIN_LENGTH: "minLength",
    REGEX: "regex"
}
